/* Lots BundleX depuis le panier (5 oct).

   1. Panier vide : « Ajouter les 2 » envoie le lot 1 acheté + 1 offert,
      exactement comme la fiche produit (quantité 2 + propriété _bundlex).
   2. Pack au panier : les boutons « 2 oreillers » / « 4 oreillers » retirent
      les lignes du pack puis ajoutent le lot choisi, dans le coloris de la
      ligne payée.

   Le tiroir et la page panier se redessinent seuls : cart-drawer.js observe
   chaque appel /cart/* et compare le nombre d'articles. Pendant l'échange,
   le verrou __ykEchangeCadeau empêche un rendu intermédiaire (panier vide). */
(function () {
  if (window.__ykPacks || !window.fetch) return;
  window.__ykPacks = true;

  function bx(el, lot) {
    var p = { d: el.getAttribute('data-bx-d') };
    p.o = lot;
    p.oid = Number(el.getAttribute(lot === 2 ? 'data-bx-o2' : 'data-bx-o1'));
    return p;
  }

  function lignes(el, variant, lot) {
    var id = Number(variant);
    if (lot === 1) {
      return [{ id: id, quantity: 2, properties: { _bundlex: JSON.stringify(bx(el, 1)) } }];
    }
    var b = Math.random().toString(36).slice(2, 8);
    var base = bx(el, 2); base.b = b;
    var items = [{ id: id, quantity: 2, properties: { _bundlex: JSON.stringify(base) } }];
    [0, 1].forEach(function (e) {
      var x = bx(el, 2); x.e = e; x.b = b;
      /* Sans parent_id : envoyé depuis le panier, Shopify le refuse
         (« Un seul niveau d'imbrication »). Le prix est le même, mesuré. */
      items.push({ id: id, quantity: 1, properties: { _bundlex: JSON.stringify(x) } });
    });
    return items;
  }

  function appel(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Erreur'); });
      return r.json();
    });
  }

  function verrou(d) {
    var v = (window.__ykEchangeCadeau || 0) + d;
    window.__ykEchangeCadeau = v > 0 ? v : 0;
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;

    var add = t.closest('[data-bx-add]');
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      var card = add.closest('.ycd__reco-card');
      var sel = card && card.querySelector('[data-cart-variant]');
      if (!sel || !sel.value) return;
      add.classList.add('is-busy');
      appel('/cart/add.js', { items: lignes(add, sel.value, 1) })
        .catch(function (err) { add.classList.remove('is-busy'); window.alert(err.message); });
      return;
    }

    var btn = t.closest('[data-bx-lot]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('is-on')) return;
      var box = btn.closest('.ykb__lots');
      var lot = Number(btn.getAttribute('data-bx-lot'));
      var cles = (box.getAttribute('data-bx-keys') || '').split(',').filter(Boolean);
      var variant = box.getAttribute('data-bx-variant');
      var maj = {};
      cles.forEach(function (k) { maj[k] = 0; });
      box.classList.add('is-busy');
      verrou(1);
      appel('/cart/update.js', { updates: maj })
        .then(function () { return appel('/cart/add.js', { items: lignes(box, variant, lot) }); })
        .catch(function (err) { window.alert(err.message); })
        .then(function () {
          verrou(-1);
          /* Un appel neutre, pour que le tiroir et la page relisent le panier
             maintenant que le verrou est levé. */
          return appel('/cart/update.js', { updates: {} });
        })
        .catch(function () {});
    }
  }, true);
})();
